import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { ocppMessageType } from '../../../../../config/enum';
import { AvailableTabProperties } from '../../../../../interface/device-management.interface';
import OCPPLogs from '../../../../ocpp-logs';

import DataManagement from './DataManagement';
import Operations from './Operations';

/**
 * Function to display Ocpp tags
 * @returns {any} The result
 */
export default function OcppConsole() {
  const { t } = useTranslation('devices');
  const [autoRefreshActive, setAutoRefreshActive] = useState<boolean>(false);
  const [ocppConsoleTabs, setOcppConsoleTabs] = useState<AvailableTabProperties[]>([
    // {
    //   label: 'Data Management',
    //   key: 'device-management',
    //   isActive: false,
    // },
    {
      label: t('operations'),
      key: 'operations',
      isActive: true,
    },
    // {
    //   label: 'Settings',
    //   key: 'settings',
    //   isActive: false,
    // },
    // {
    //   label: 'Profile',
    //   key: 'profile',
    //   isActive: false,
    // },
    // {
    //   label: 'User',
    //   key: 'user',
    //   isActive: false,
    // },
  ]);

  const [searchParameters] = useSearchParams();

  /**
   * Helper function to determine the tab label.
   * @param {string} tabLabel - The default tab label.
   * @returns {string} The active tab label.
   */
  const getTabLabel = (tabLabel: string): string => {
    const hideSidebar = searchParameters.get('hideSidebar') === 'true';
    const operation = searchParameters.get('operation');
    if (hideSidebar && operation) {
      switch (operation) {
        case ocppMessageType.CHANGE_AVAILABILITY:
          return t('changeAvailability');
        case ocppMessageType.GET_CONFIGURATION:
          return t('getConfiguration');
        case ocppMessageType.CHANGE_CONFIGURATION:
          return t('changeConfiguration');
        case ocppMessageType.CHANGE_CONFIGURATION_CUSTOM:
          return t('changeConfiguration(Custom)');
        case ocppMessageType.CLEAR_CACHE:
          return t('clearCache');
        case ocppMessageType.RMT_START_TRANSACTION:
          return t('remoteStartTransaction');
        case ocppMessageType.RMT_STOP_TRANSACTION:
          return t('remoteStopTransaction');
        case ocppMessageType.RESET_CP:
          return t('reset');
        case ocppMessageType.UNLOCK_CONNECTOR:
          return t('unlockConnector');
        case ocppMessageType.TRIGGER_MESSAGE:
          return t('triggerMessage');
        case ocppMessageType.UPDATE_FIRMWARE:
          return t('updateFirmware');
        case ocppMessageType.GET_DIAGNOSTICS:
          return t('getDiagnostics');
        case ocppMessageType.GET_LOCAL_LIST_VERSION:
          return t('getLocalListVersion');
        case ocppMessageType.SET_CHARGING_PROFILE:
          return t('setChargingProfile');
        case ocppMessageType.CLEAR_CHARGING_PROFILE:
          return t('clearChargingProfile');
        default:
          return tabLabel;
      }
    }
    return tabLabel;
  };

  /**
   * Function to switch the tab
   * @param {string} key - The key
   */
  const handleSwitchTab = (key: string) => {
    setOcppConsoleTabs((previousTabs: AvailableTabProperties[]) =>
      previousTabs.map((tab) => {
        if (tab.key === key) {
          return {
            ...tab,
            isActive: true,
          };
        }
        return {
          ...tab,
          isActive: false,
        };
      }),
    );
  };

  /**
   * Callback when any OCPP action is triggered by the user
   */
  const handleActionTriggered = () => {
    setAutoRefreshActive(true);
  };

  return (
    <div className="device-ocpp-console-wrap">
      <div className="ocpp-console-tabs">
        {ocppConsoleTabs.map((tab) => (
          <div
            key={tab.key}
            className={`each-tab ${tab.isActive ? 'active' : ''}`}
            role="presentation"
            onClick={() => handleSwitchTab(tab.key)}>
            <h6>{getTabLabel(tab.label)}</h6>
            <div className="bottom-green" />
          </div>
        ))}
      </div>
      <div className="device-ocpp-console-container">
        {(() => {
          const activeTab = ocppConsoleTabs.find((tab) => tab.isActive);
          let dataToShow = null;
          if (activeTab) {
            switch (activeTab.key) {
              case 'device-management':
                dataToShow = <DataManagement />;
                break;
              case 'operations':
                dataToShow = <Operations onActionTriggered={handleActionTriggered} />;
                break;
              default:
                dataToShow = null;
            }
          }
          return dataToShow;
        })()}
      </div>
      <OCPPLogs
        autoRefreshEnabled={autoRefreshActive}
        disableAutoRefreshToggle
        hideAccountStationChargerFilters
      />
      <div />
    </div>
  );
}

